import PropTypes from 'prop-types'

import classNames from 'classnames'
import Icon from 'components/Icon'

const SortIcon = ({ sortItem }) => (
  <Icon
    name="sort"
    className={classNames(
      'ico_comm',
      sortItem.reverse
        ? {
            sort_up: sortItem.order === 'desc',
            sort_down: sortItem.order === 'asc',
          }
        : {
            sort_up: sortItem.order === 'asc',
            sort_down: sortItem.order === 'desc',
          }
    )}>
    정렬
  </Icon>
)

export default SortIcon

SortIcon.propTypes = {
  sortItem: PropTypes.shape({
    order: PropTypes.string.isRequired,
    reverse: PropTypes.bool,
  }).isRequired,
}
